import moment from 'moment';

function twitchLink(videoUrl, segmentStart) {
  if (!videoUrl) {
    return '';
  }

  if (segmentStart) {
    const momentSS = moment.utc(segmentStart * 1000);
    const platform = videoUrl.substr(12, 6);

    return (
      videoUrl +
      `${platform === 'twitch' ? '?' : '&'}t=${momentSS.format(
        'HH'
      )}h${momentSS.format('mm')}m${momentSS.format('ss')}s`
    );
    // https://www.twitch.tv/videos/603719988?t=0h33m52s
  }
}

export default twitchLink;
